var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotline2Green(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.519,
    height: 34.825,
    viewBox: "0 0 34.519 34.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eg\\xE9szs\\xE9g_hotline_-_z\\xF6ld",
    transform: "translate(12918.031 13707.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eg\\xE9szs\\xE9g_hotline",
    transform: "translate(-12917 -13703.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    d: "M1594.958,431.572h0l.007-.013,2.921-5.187-6.9-4.785-3.979,2.033.145,4.824a17.762,17.762,0,0,1-13.426-13.4l4.779.145,2.033-3.979-3.85-5.551-.172-.25-.763-1.1-5.2,2.927h0a7.229,7.229,0,0,0-.733.639c-4.278,4.279-2.27,13.226,4.488,19.984s15.705,8.764,19.983,4.487a6.729,6.729,0,0,0,.665-.772.018.018,0,0,0,.01-.013",
    transform: "translate(-1567.574 -404.306)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10801",
    d: "M1590.043,413.8",
    transform: "translate(-1564.254 -402.902)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10802",
    d: "M1585.174,408.935",
    transform: "translate(-1564.973 -403.622)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10842",
    d: "M1589.536,406.318h-4.2v3.71h4.2v4.191h3.71v-4.191h4.191v-3.71h-4.191v-4.2h-3.71Z",
    transform: "translate(-14481.949 -14108.289)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotline2Green);
export default __webpack_public_path__ + "static/media/hotline2Green.6833a620c260029ca98c87285b043fed.svg";
export { ForwardRef as ReactComponent };